export async function getFetchFn() {
    return fetch;
}
